export interface Volume {
  icon: string
  number: string
  title: string
  subtitle: string
  problem: string
  bullets: string[]
  result: string
  badge?: string
}

export const volumes: Volume[] = [
  {
    icon: '📗',
    number: 'Volume 1 — Les fondations essentielles',
    title: 'Les fondations essentielles',
    subtitle: 'Salutations · Chiffres · Famille · Descriptions · Se présenter',
    problem:
      "Enseigner à des débutants est l'une des parties les plus gratifiantes — et les plus exigeantes — d'être professeur d'espagnol. Ce volume te donne tout ce qu'il faut pour guider tes nouveaux élèves avec clarté et structure, sans improviser une seule activité.",
    bullets: [
      "Comment introduire la langue et les routines de classe dès la première leçon",
      "Comment guider des élèves qui n'ont jamais parlé espagnol",
      'Comment construire une vraie rétention de vocabulaire par la répétition significative',
      'Différenciation et options d’adaptation intégrées dans chaque leçon',
    ],
    result: 'Tes débutants se sentent capables, soutenus et motivés à continuer — dès leur premier cours.',
    badge: 'PLUS POPULAIRE',
  },
  {
    icon: '📘',
    number: 'Volume 2 — École · Routines · Nourriture · Loisirs',
    title: 'École · Routines · Nourriture · Loisirs',
    subtitle: 'Verbes au présent — structurés, progressifs, prêts à enseigner',
    problem:
      "Passer les élèves de l'espagnol de survie à la communication réelle est la transition la plus difficile. Ce volume te donne des leçons complètement structurées qui couvrent ce fossé — en construisant vocabulaire, routines et le système verbal complet au présent avec une progression naturelle.",
    bullets: [
      "Comment construire des leçons qui connectent le vocabulaire à la vie réelle de l'élève",
      'Comment introduire les verbes réguliers et irréguliers au présent en contexte',
      "Comment maintenir l'engagement avec une vraie variété sur plusieurs semaines",
      "Activités guidées et tâches d'expression orale prêtes pour chaque leçon",
    ],
    result:
      'Tu enseignes les semaines intermédiaires de Spanish 1 avec confiance et tes élèves développent une vraie capacité communicative — pas juste des listes mémorisées.',
    badge: 'PLUS POPULAIRE',
  },
  {
    icon: '📙',
    number: 'Volume 3 — Grammaire intermédiaire approfondie',
    title: 'Grammaire intermédiaire approfondie',
    subtitle: 'Passé · Futur · Conditionnel · Pronoms COD/COI · Narration',
    problem:
      "Les structures qui séparent les vrais locuteurs des débutants — et les concepts avec lesquels les élèves ont le plus de difficultés. Ce volume te donne toutes les leçons, explications, exemples et activités de pratique déjà créés.",
    bullets: [
      'Comment introduire le passé étape par étape — formes régulières et irrégulières',
      'Comment enseigner le futur et le conditionnel avec une logique claire et une pratique immédiate',
      "Comment développer progressivement les compétences de narration et d'expression des opinions",
      'Comment travailler por et para, les comparatifs et les connecteurs de discours',
    ],
    result: 'Tes élèves maîtrisent la grammaire la plus complexe — et toi tu l’enseignes avec une clarté qui la rend simple.',
  },
  {
    icon: '📕',
    number: 'Volume 4 — Expression orale & Communication réelle',
    title: 'Expression orale & Communication réelle',
    subtitle: 'Fluidité orale · Situations réelles · Conseils · Hypothèses',
    problem:
      "La phase où les élèves consolident tout ce qu'ils ont appris — ou perdent le fil. Ce volume te donne une pratique orale structurée, des situations de communication authentiques et tout le matériel prêt pour la fin d'année.",
    bullets: [
      'Comment construire une vraie fluidité orale via des débats, présentations et tâches spontanées',
      "Comment enseigner les hypothèses, les conseils et l'introduction au subjonctif",
      'Comment travailler les voyages, la technologie, la santé et les expériences personnelles',
      'Comment évaluer équitablement avec des rubriques et des corrigés déjà prêts',
    ],
    result:
      "Tes élèves terminent l'année capables de parler, lire, écrire et comprendre l'espagnol à un niveau qui ouvre de vraies portes.",
  },
  {
    icon: '📒',
    number: 'Volume 5 — Révision, Évaluation & Consolidation',
    title: 'Révision, Évaluation & Consolidation',
    subtitle: 'Révision de toutes les compétences · Points d’évaluation · Consolidation',
    problem:
      "Un volume entièrement dédié à vérifier, consolider et valider les apprentissages — pour que tu n'aies jamais à créer des révisions de zéro en fin de période ou d'année.",
    bullets: [
      'Comment organiser des révisions ciblées par compétence sans improviser',
      'Comment préparer les élèves aux évaluations avec confiance',
      "Comment mesurer les progrès à différentes étapes de l'année",
      'Toutes les clés de correction déjà incluses pour gagner du temps',
    ],
    result:
      'Tu entres dans chaque fin de période avec une structure claire et tes élèves arrivent aux évaluations vraiment préparés.',
  },
  {
    icon: '📔',
    number: 'Volume 6 — Culture, Compréhension & Projets',
    title: 'Culture, Compréhension & Projets',
    subtitle: 'Monde hispanophone · Projets d’élèves · Compréhension écrite et orale',
    problem:
      "Le volume qui donne de la vie à ton enseignement — avec des leçons culturelles authentiques, des projets d'élèves structurés et des activités de compréhension qui sortent du manuel classique.",
    bullets: [
      'Comment intégrer la culture hispanophone de façon authentique et non générique',
      "Comment guider des projets d'élèves sans que ça devienne une source de stress",
      "Comment varier les formats pour maintenir l'engagement sur toute l'année",
      'Mexique, Espagne, Colombie, Argentine, Amérique centrale et plus',
    ],
    result: 'Tes cours culturels se sentent comme une vraie expérience — pas juste une fiche de lecture de plus.',
  },
  {
    icon: '🗓️',
    number: 'Spanish 1 — Programme Annuel Complet',
    title: 'Spanish 1 — Programme Annuel Complet',
    subtitle: 'Feuille de route complète pour organiser toute une année de niveau débutant',
    problem:
      "Toute la progression de l'année de débutant déjà organisée, semaine après semaine, pour que tu saches exactement quoi enseigner et dans quel ordre.",
    bullets: [
      'Salutations, présentation, âge, nationalité, famille, école, routines',
      'Loisirs, nourriture, ville, achats, météo, heure et dates',
      'Présent régulier et irrégulier, ser, estar, hay, tener, ir, gustar',
      'Adjectifs, négation, questions et prépositions essentielles',
    ],
    result: 'Tu as une feuille de route annuelle complète — sans devoir reconstruire ta progression chaque trimestre.',
    badge: 'PROGRAMME ANNUEL COMPLET',
  },
  {
    icon: '🗓️',
    number: 'Spanish 2 — Programme Annuel Complet',
    title: 'Spanish 2 — Programme Annuel Complet',
    subtitle: 'La suite directe — pour développer un espagnol plus autonome et plus fluide',
    problem:
      "La continuité naturelle de Spanish 1 : une année entière structurée pour amener tes élèves vers l'autonomie réelle en espagnol.",
    bullets: [
      'Approfondissement du présent + introduction progressive du passé, futur, conditionnel',
      'Impératif, pronoms COD/COI, por et para, comparatifs, connecteurs',
      'Narration, opinions, conseils, hypothèses, introduction au subjonctif',
      'Voyages, expériences, santé, technologie, culture et situations réelles',
    ],
    result: 'Tes élèves de Spanish 2 développent une vraie autonomie en espagnol — pas juste plus de vocabulaire mémorisé.',
    badge: 'PROGRAMME ANNUEL COMPLET',
  },
]
